import React from 'react';
import { Icon, Video, CardsThree, Stack } from '@phosphor-icons/react';

import { Button } from '../../../components/general';
import AttendeePanel from './attendeePanel';

interface Props {
  isCreationAccess: boolean;
  isClipsAccess: boolean;
}

const DownloadPanel: React.FC<Props> = (props) => {
  const { isCreationAccess, isClipsAccess } = props;

  const btns: { Icon: Icon; label: string }[] = [
    { Icon: Video, label: 'Download Highlight Reel' },
    { Icon: CardsThree, label: 'Download Your Clips' },
    { Icon: Stack, label: 'Download All' },
  ];

  const noteText =
    !isCreationAccess && !isClipsAccess
      ? 'all downloaded assets'
      : !isCreationAccess
        ? 'the downloaded highlight reel'
        : !isClipsAccess
          ? 'the downloaded clips'
          : null;

  return (
    <AttendeePanel
      heading="Download Center"
      className="w-[30%] items-center text-center"
    >
      {btns.map((btn) => (
        <Button
          key={btn.label}
          colour="black-outline"
          className="w-full font-semibold"
          withGap
        >
          <btn.Icon size="1.25rem" />
          <div>{btn.label}</div>
        </Button>
      ))}

      {noteText && (
        <div className="text-sm italic">
          Note: {noteText} will <b>have a watermark</b>.
        </div>
      )}
    </AttendeePanel>
  );
};

export default DownloadPanel;
